"use client";

import Link from "next/link";

export const isHashHref = (href) =>
  typeof href === "string" && href.startsWith("#");

/**
 * One nav link, whatever it points at.
 *
 * In-page anchors stay plain <a> elements: the client router's hash push does
 * not fire `hashchange`, which the playbook listens to for opening a section.
 * Off-site links open in a new tab. `aria-current` is "location" for an anchor
 * and "page" for a route.
 */
export default function NavAnchor({
  href,
  active = false,
  external = false,
  children,
  ...props
}) {
  if (external) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  }

  const inPage = isHashHref(href);
  const Tag = inPage ? "a" : Link;
  return (
    <Tag
      href={href}
      aria-current={active ? (inPage ? "location" : "page") : undefined}
      {...props}
    >
      {children}
    </Tag>
  );
}
